import { render, staticRenderFns } from "./CardType.vue?vue&type=template&id=7f04996b&scoped=true&"
import script from "./CardType.vue?vue&type=script&lang=js&"
export * from "./CardType.vue?vue&type=script&lang=js&"
import style0 from "./CardType.vue?vue&type=style&index=0&id=7f04996b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04996b",
  null
  
)

export default component.exports